module.exports = __webpack_public_path__ + "assets/img/Ranking.dd24c6a3.png";